/*
 * Module for the Employer Account Activity Report criteria page
 */
rs.module("content/reports/employeraccountactivitycriteria",

    ["common/select-helper"],

    function (selectHelper) {

        var _jsSelectors;
        var _backendUrls;
        var _filterOptionValues;
        var _criteria;

        // initialize the page
        function initialize(jsSelectors, backendUrls, filterOptionValues) {

            // initialize module-scoped variables 
            _jsSelectors = jsSelectors;
            _backendUrls = backendUrls;
            _filterOptionValues = filterOptionValues;
            _criteria = $.js(_jsSelectors.criteria);

            // register employer changed event
            _criteria.js(_jsSelectors.employerSelect).change(employerChanged);

            // register filter changed event
            _criteria.js(_jsSelectors.filterSelect).change(filterOptionChanged);

            // setup filters on DOM ready
            $(filterOptionChanged);
        }

        // employer dropdown changed handler
        function employerChanged() {

            // re-bind plan and visible filter dropdowns
            rebindDropDown(_criteria.js(_jsSelectors.planSelect), _backendUrls.planBackendUrl, true);
            rebindSelectedFilterDropdown();
        }

        // calls generic _rebindDropDown with params specific to which filter dropdown is visible
        function rebindSelectedFilterDropdown() {

            var selectedFilterSelector = getSelectedFilterSelector();
            var targetBackendUrl;

            // determine backend url for visible filter dropdown
            switch (selectedFilterSelector) {
                case _jsSelectors.batchSelect:
                    targetBackendUrl = _backendUrls.batchBackendUrl;
                    break;

                case _jsSelectors.voucherSelect:
                    targetBackendUrl = _backendUrls.voucherBackendUrl;
                    break;

                case _jsSelectors.fiscalYearSelect:
                    targetBackendUrl = _backendUrls.fiscalYearBackendUrl;
                    break;

                default:
                    break;
            }

            // re-bind
            rebindDropDown(_criteria.js(selectedFilterSelector), targetBackendUrl, false);
        }

        // gets the selector for visible filter option
        function getSelectedFilterSelector() {

            switch (_criteria.js(_jsSelectors.filterSelect).val()) {
                case _filterOptionValues.batchNumber:
                    return _jsSelectors.batchSelect;

                case _filterOptionValues.voucherNumber:
                    return _jsSelectors.voucherSelect;

                case _filterOptionValues.fiscalYear:
                    return _jsSelectors.fiscalYearSelect;

                case _filterOptionValues.dateRange:
                    return _jsSelectors.fromTextBox;

                default:
                    return;
            }
        }

        // fill the specified dropdown using the specified Ajax call
        function rebindDropDown(ddl, backendUrl, needsBlankOption) {

            // Get Select Helper for specified drop down since we're updating its options and properties
            var ddlselectHelper = selectHelper.getHelper(ddl);

            // get selected employer key
            var selectedEmployerKey = _criteria.js(_jsSelectors.employerSelect).val();

            // populate job schedules based on selected job
            ddlselectHelper.loadOptionsFrom(backendUrl, { employerKey: selectedEmployerKey }, { withBlank: needsBlankOption });
        }

        // filter option (Activity For) dropdown changed handler
        function filterOptionChanged() {

            // hide all filter rows
            _criteria.js(_jsSelectors.filterRow, { multiple: true }).hide();

            // re-bind specified row
            rebindSelectedFilterDropdown();

            // show specified row
            _criteria.js(getSelectedFilterSelector()).closest(_criteria.js(_jsSelectors.filterRow, { multiple: true })).show();
        }

        var exports = {
            initialize: initialize
        };

        return exports;
    }
);